import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import { AUTHORIZATION_CODE_QUERY_PARAM } from '@wix/thunderbolt-symbols'

const windowMessageRegistrarSiteConfig: SiteConfigFn<never> = ({ api, funcLib }) => {
	const requestUrl = api.originalRequest.getUrl()
	const isRunningInDifferentSiteContext = !!funcLib.getQueryParamValue(requestUrl, AUTHORIZATION_CODE_QUERY_PARAM)
	const shouldLoadSiteFeature = api.features.isActive('tpaCommons') || isRunningInDifferentSiteContext

	return {
		shouldLoadSiteFeature,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'windowMessageRegistrar'

export const config = { site: windowMessageRegistrarSiteConfig, name }
